import { isBrowser } from 'ws-scripts/modules/environment';

export const publishEvent = (topic, ...params) => {
	if (isBrowser && window?.DDC?.pubsub) {
		window.DDC.pubsub.publish(topic, ...params);
	}
};
